import { useStaticQuery, graphql } from 'gatsby'

export default () => {
  const data = useStaticQuery(graphql`
    query Magazine {
      allContentfulArticle {
        edges {
          node {
            id,
            title,
            url,
            excerpt {
              excerpt
            }
            date,
            body {
              id,
              body
            }
          }
        }
      }
    }
  `)

  return data.allContentfulArticle.edges.reduce((listOfArticles, currArticle) => {
    const article = {
      id: currArticle.node.id,
      title: currArticle.node.title,
      url: currArticle.node.url,
      excerpt: currArticle.node.excerpt.excerpt,
      body: currArticle.node.body.body,
      date: currArticle.node.date,
    }

    return [...listOfArticles, article]
  }, [])
}
